import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './SameJourneyLogistic.less';

export default class SameJourneyLogistic extends OfficialPage {
  state = {
    info: {},
    logistics: [],
    arriveTime: '',
    sameCity: 0
  }
  orderId = ''
  franchiseeId = ''

  constructor(props) {
    super(props);
    document.title = '配送信息';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let type = options.type
    let sameCity = options.sameCity
    this.orderId = options.orderId
    this.franchiseeId = options.franchiseeId || ''
    this.getTransportOrderFlow()
    if (type == 0) {
      this.getSameJourneySet()
    } else {
      this.getTransporterInfo()
    }
    this.setData({
      type: type,
      arriveTime: options.arriveTime,
      sameCity: sameCity
    })
  }

  getTransporterInfo = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/queryTransporterInfo',
      data: {
        order_id: _this.orderId,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        let data = res.data
        let riderMakers = [
          {
            latitude: data.transporterLat,
            longitude: data.transporterLng,
            iconPath: '/images/transport.png',
            width: 50,
            height: 50,
            callout: {
              content: '距离店铺' + data.tripartite_info.distance + '米',
              fontSize: 11,
              color: '#333333',
              borderRadius: 4,
              bgColor: '#ffffff',
              padding: 10,
              display: 'ALWAYS',
              textAlign: 'center'
            }
          }
        ]
        _this.setData({
          info: data,
          riderMakers: riderMakers,
          centerLatitude: +data.transporterLat + +0.0004,
          centerLongitude: data.transporterLng,
          showMap: true
        })
      }
    })
  }
  getTransportOrderFlow = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/getTransportOrderFlow',
      data: {
        order_id: _this.orderId,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        _this.setData({
          logistics: res.data.reverse()
        })
      }
    })
  }
  getSameJourneySet = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
      data: {
        pick_up_type: 2,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        let storeData = res.data.app_store_data
        let riderMakers = [
          {
            latitude: storeData.latitude,
            longitude: storeData.longitude,
            iconPath:
              'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/merchant-delivery.png',
            width: 47,
            height: 51,
            callout: {
              content: '商家配送暂无配送信息',
              fontSize: 11,
              color: '#333333',
              borderRadius: 4,
              bgColor: '#ffffff',
              padding: 5,
              display: 'ALWAYS',
              textAlign: 'center'
            }
          }
        ]
        _this.setData({
          riderMakers: riderMakers,
          centerLatitude: +storeData.latitude + 0.0004,
          centerLongitude: storeData.longitude,
          phone: storeData.contact_phone,
          showMap: true
        })
      }
    })
  }
  contactPhone = event => {
    app.makePhoneCall(event.currentTarget.dataset.phone)
  }

  render() {
    const {
      showGetUserInfo,
      type,
      logistics,
      arriveTime,
      showMap,
      centerLongitude,
      centerLatitude,
      riderMakers,
      phone,
      info,
      sameCity
    } = this.state

    return (
      <div className="official-page same-journey-logistic">
        <TopNav title="配送信息"/>
        {sameCity == 0 && (
          <div className="journey-logistics-header">
            <div className="logistic-status">
              {type == 0 ? '商家自配送' : logistics[0] && logistics[0].content.msg}
            </div>
            {arriveTime && (
              <div className="service-time">
                预计送达时间：<span>{arriveTime}</span>
              </div>
            )}
            {showMap && (
              <React.Fragment>
                {/* TODO <Map
                  longitude={centerLongitude}
                  latitude={centerLatitude}
                  scale="18"
                  markers={riderMakers}
                ></Map> */}
              </React.Fragment>
            )}
            {type == 0 ? (
              <div className="rider-info">
                商家信息
                <span
                  onClick={this.contactPhone}
                  data-phone={phone}
                  className="pull-right contact-rider"
                >
                  联系商家
                </span>
              </div>
            ) : (
                <div className="rider-info">
                  骑手信息
                {info.transporter_phone && (
                    <span
                      onClick={this.contactPhone}
                      data-phone={info.transporter_phone}
                      className="pull-right contact-rider"
                    >
                      联系骑手
                  </span>
                  )}
                  <span className="pull-right rider-name">
                    {info.transporterName}
                  </span>
                </div>
              )}
          </div>
        )}
        <div id="logisticsPage">
          <div className="logistics-container">
            <div className="logistics-list">
              {logistics.map((item, index) => {
                return (
                  <div key={item.id} className="logistics-item">
                    <div className="logistics-location">
                      {item.content.msg}
                    </div>
                    <div className="logistics-time">{item.op_time}</div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/same-journey-logistic/SameJourneyLogistic.jsx